import { render, staticRenderFns } from "./BloodParasite.vue?vue&type=template&id=3e60a9fc&scoped=true&"
import script from "./BloodParasite.vue?vue&type=script&lang=js&"
export * from "./BloodParasite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e60a9fc",
  null
  
)

export default component.exports